// Libraries
import React, { useState, useContext } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faBolt } from '@fortawesome/free-solid-svg-icons';
import Tooltip from '@mui/material/Tooltip';

// Import Component
import UpgradeMembership from '../../components/Modals/Subscription/upgradeMembership.js';

// Context
import { UserContext } from '../../context/User';
import SessionContext from '../../context/Session';

// Construct Component
const UserCreditBar = ({ level, availableCredits }) => {
  const [modalIsOpen, setModalIsOpen] = useState(false);
  const { isMobile } = useContext(SessionContext);

  function closeMembershipModal() {
    setModalIsOpen(false);
  }

  const showUpgrade = !!availableCredits && level !== 'pro' && availableCredits.totalCredits < 100;
  const showGetMore = level === 'pro' && availableCredits.totalCredits < 100;

  const showFreemiumBonusTooltip =
    !!availableCredits &&
    (!availableCredits.totalCredits || availableCredits.totalCredits === 0) &&
    (availableCredits.basicFreemium ?? 0) >= 1;

  const upgradeButtonContent = (
    <>
      <FontAwesomeIcon icon={faBolt} style={{ marginRight: 8 }} />
      Upgrade
    </>
  );

  const creditBar = (
    <div
      className="fullWidthContainer"
      style={{
        marginBottom: isMobile && showUpgrade ? '12px' : '25px',
        background: '#e7defaff',
        borderRadius: '15px',
        width: '100%',
      }}
    >
      <div
        style={{
          display: 'flex',
          alignItems: 'center',
          padding: '15px 18px',
          width: '100%',
          gap: '12px',
        }}
      >
        {/* Sparkles */}
        <span
          className="sparklesIcon"
          style={{
            display: 'flex',
            alignItems: 'center',
          }}
        >
          <svg width="40" height="40" viewBox="0 0 40 40" fill="none">
            {/* Large Star */}
            <path d="M20 4l3 8 8 3-8 3-3 8-3-8-8-3 8-3 3-8z" fill="#9C4DFF" />
            {/* Small Star 1 */}
            <path d="M31.5 14l1.6 4 4 1.6-4 1.6-1.6 4-1.6-4-4-1.6 4-1.6 1.6-4z" fill="#C39BFF" />
            {/* Small Star 2 */}
            <path
              d="M35.5 21.5l1.3 3.3 3.3 1.3-3.3 1.3-1.3 3.3-1.3-3.3-3.3-1.3 3.3-1.3 1.3-3.3z"
              fill="#B57CFF"
            />
          </svg>
        </span>

        {/* Text */}

        {showGetMore ? (
          <a
            className="sizeUp"
            style={{
              flex: 1,
              textDecoration: 'none',
            }}
            href="https://www.shotkraft.com/contact-us"
            target="_blank"
          >
            All Pro credits used for this month. No worries! <u>Click here</u> to message us and
            we'll add more.
          </a>
        ) : (
          <span
            className="sizeUp"
            style={{
              flex: 1,
            }}
          >
            {availableCredits?.basicFreemium ? (
              <>
                You can generate the shotlist for
                <span className="purpleText bold"> 2 projects</span> (first
                <span className="purpleText bold"> 5 scenes</span> open for edit).
                {availableCredits.totalCredits >= 100 ? (
                  <>
                    {' '}
                    and{' '}
                    <span className="purpleText bold">
                      {availableCredits.totalCredits / 100}
                    </span>{' '}
                    more scripts this month.
                  </>
                ) : null}
                {' '}Upgrade to Pro for unlimited editing and export, and other advanced features.
              </>
            ) : (
              <>
                You can generate a shotlist for
                {availableCredits ? (
                  <span style={{ marginLeft: '2px' }}>
                    {showUpgrade ? (
                      <> 0 scenes of your next project. </>
                    ) : availableCredits.totalCredits >= 100 ? (
                      <span>
                        {' '}
                        <span className="purpleText bold">
                          {availableCredits.totalCredits / 100}
                        </span>{' '}
                        more scripts this month
                      </span>
                    ) : (
                      <span> 0 scenes of your next project </span>
                    )}
                  </span>
                ) : (
                  <span> 0 scenes of your next project.</span>
                )}
                {showUpgrade
                  ? ' Upgrade to pro for unlimited scenes and advanced features.'
                  : null}
              </>
            )}
          </span>
        )}

        {/* Desktop / non-mobile: inline upgrade button inside purple bar */}
        {showUpgrade && !isMobile && (
          <button
            onClick={() => setModalIsOpen(true)}
            className="linkText buttonClone"
            style={{
              whiteSpace: 'nowrap',
              display: 'flex',
              alignItems: 'center',
              padding: '10px 45px',
            }}
          >
            {upgradeButtonContent}
          </button>
        )}
      </div>
    </div>
  );

  return (
    <>
      <UpgradeMembership
        isOpen={modalIsOpen}
        onRequestClose={closeMembershipModal}
        featureMsg={'Upgrade to pro for more generated scenes and premium features.'}
        scriptId={null}
      />

      {creditBar}

      {/* Mobile: full-width upgrade button outside the purple bar */}
      {showUpgrade && isMobile && (
        <button
          onClick={() => setModalIsOpen(true)}
          className="linkText buttonClone"
          style={{
            width: '100%',
            borderRadius: '999px',
            padding: '16px 25px',
            marginBottom: '20px',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            fontWeight: 600,
            fontSize: '16px',
            gap: '8px',
          }}
        >
          {upgradeButtonContent}
        </button>
      )}
    </>
  );
};

export default UserCreditBar;
